<template>
	<div class="setting-page">
		<div class="ft20 cl-main ftw600">优惠规则列表</div>
			
		<div class="form-search-box mt20">
			<a-form layout="inline">
				<!-- <a-form-item label="所属门店">
					<div>
						<a-select style="width: 120px" placeholder="请选择" v-model="search.mendian_id">
							<a-select-option :value="0">请选择</a-select-option>
							<a-select-option :value="item.mendian_id" v-for="(item,index) in mendians" :key="index">{{item.name}}</a-select-option>
						</a-select>
					</div>
				</a-form-item> -->
				<a-form-item label="规则名称">
					<a-input v-model="search.keyword" placeholder="请输入规则名称"></a-input>
				</a-form-item>
				<a-form-item>
					<a-button @click="searchAct" type="primary">查询</a-button>
					<a-button @click="cancelAct" class="ml10">取消</a-button>
				</a-form-item>
			</a-form>
		</div>
			
		<div  class="mt20">
			<a-button type="primary"  @click="addAct">新增规则</a-button>

			<a-button type="primary"  @click="importActModel" style="margin-left: 20px;">下载导入用户模板</a-button>
		</div>

		<div class="mt20">
			<div class="wxb-table-white">
				<a-table rowKey="rule_id" :columns="columns" :pagination="pagination" @change="handleTableChange" :data-source="datas"
					:loading="loading">

					<!-- <template slot="mendian_slot" slot-scope="text,record">
						{{text ? text.name : '-'}}
					</template> -->

					<template slot="status_slot" slot-scope="text,record">
						{{text == 1 ? '正常' : '失效'}}
					</template>

					<template slot="action" slot-scope="record,index">
						<div class="flex center">
							<a-dropdown placement="bottomRight">
								<span class="more-act">
									<i class="iconfont iconmore_gray"></i>
								</span>
								<a-menu slot="overlay">
									<a-menu-item>
										<a class="menu-act" href="javascript:;" @click="editAct(record)">
											<span>编辑规则</span>
										</a>
									</a-menu-item>

									<a-menu-item>
										<a class="menu-act" href="javascript:;" @click="importUserAct(record)">
											<span>导入用户</span>
										</a>
									</a-menu-item>

									<a-menu-item>
										<a class="menu-act" href="javascript:;" @click="editUserAct(record)">
											<span>编辑导入用户</span>
										</a>
									</a-menu-item>

									<!-- <a-menu-item>
										<a class="menu-act" href="javascript:;" @click="downloadUsers(record)">
											<span>导出用户</span>
										</a>
									</a-menu-item> -->
									
									<a-menu-item>
										<a class="menu-act" href="javascript:;" @click="delAct(record)">
											<span>删除规则</span>
										</a>
									</a-menu-item>
								
								</a-menu>
							</a-dropdown>
						</div>
					</template>
				</a-table>
			</div>
		</div>

		<!-- 导入用户弹框 -->
		<a-modal
			title="导入用户"
			:visible="importVisible"
			:confirm-loading="importLoading"
			@ok="handleImportOk"
			@cancel="handleImportCancel"
			:destroyOnClose="true"
		>
			<div class="import-container">
				<div class="mb20">
					<a-alert message="导入说明" description="请先下载模板，按照模板格式填写用户信息（rule_id, mobile），然后上传Excel文件。" type="info" show-icon />
				</div>
				
				<div class="mb20">
					<p>选择规则：</p>
					<a-select v-model="importForm.rule_id" style="width: 200px;" placeholder="请选择规则">
						<a-select-option v-for="item in datas" :key="item.rule_id" :value="item.rule_id">
							{{ item.name }} (ID: {{ item.rule_id }})
						</a-select-option>
					</a-select>
				</div>

				<div class="mb20">
					<p>上传文件：</p>
					<a-upload
						name="file"
						accept=".xlsx,.xls"
						:multiple="false"
						:before-upload="beforeUpload"
						:show-upload-list="false"
					>
						<a-button> <a-icon type="upload" /> 选择Excel文件 </a-button>
					</a-upload>
				</div>

				<div v-if="selectedFile" class="file-info">
					<p>已选择文件：{{ selectedFile.name }}</p>
					<a-button type="link" @click="selectedFileAgain()">重新选择</a-button>
				</div>

				<div v-if="importResult" class="import-result">
					<a-alert
						:message="importResult.message"
						:description="importResult.description"
						:type="importResult.type"
						show-icon
					/>
				</div>
			</div>
		</a-modal>
			
		<div>
			<discount-form v-if="showForm" @ok="formOk" @closed="formClosed" :datas="detail"></discount-form>
		</div>

		<div>
			<member-form v-if="showMemberForm" @ok="memberFormOk" @closed="memberFormClosed" :datas="detail"></member-form>
		</div>
			
	</div>
</template>

<script>
	import {listMixin} from '../../common/mixin/list.js';
	import discountForm from './components/discount/form.vue';
	import memberForm from './components/discount/memberForm.vue';
	import * as XLSX from 'xlsx';
	
	export default{
		mixins: [listMixin],
		components:{
			discountForm,
			memberForm
		},
		computed:{
			// checkCanAdd(){
			// 	return  this.maxOpenNum > this.pagination.total;
			// }
		},
		data(){
			return {
				loading: false,
				showForm:false,
				showMemberForm:false,
				detail:{
					rule_id:0,
					mendian_id:0,
					name:'',
					discount:0,
					info:'',
					status:1,
				},
				pagination: {
					current: 1,
					pageSize: 10, //每页中显示10条数据
					total: 0,
				},
				search: {
					keyword:'',
					mendian_id:0
				},
				maxOpenNum:0,
				columns: [
					{title: '规则ID',dataIndex: 'rule_id',align: 'center'},
					{title: '规则名称',dataIndex: 'name',align: 'center'},
					{title: '折扣',dataIndex: 'discount',align: 'center'},
					//{title: '所属门店',dataIndex: 'mendian',align: 'center',scopedSlots: {customRender: 'mendian_slot'}},
					{title: '说明',dataIndex: 'info',align: 'center'},
					{title: '状态',dataIndex: 'status',align: 'center',scopedSlots: {customRender: 'status_slot'}},
					{title: '操作',key: 'action',align: 'center',scopedSlots: {customRender: 'action'}},
				],
				datas: [],
				mendians: [],
				importVisible: false,
				importLoading: false,
				selectedFile: null,
				importResult: null,
				importForm: {
					rule_id: null
				}
			}
		},
		created(){
			this.getLists();
			this.getMendians();
		},
		methods:{
			getMendians(){
				this.$http.api('admin/getAllMendian').then(res=>{
					this.mendians = res.mendian;
				}).catch(res=>{
					console.log(res);
				});
			},
			addAct(){
				/*if(this.checkCanAdd){
					this.detail = {
						mendian_id:0,
						name:'',
						tel:'',
						lng:'',
						lat:'',
						address:'',
					}
					this.showForm = true;
				}else{
					this.$error({
					        title: '错误提示',
					        content: '您可最多可创建'+this.maxOpenNum+'个门店',
					});
				}*/
				this.detail = {
					rule_id:0,
					mendian_id:0,
					name:'',
					discount:0,
					info:'',
					status:1,
				}
				this.showForm = true;
			},
			editAct(res){
				this.detail = res;
				this.showForm = true;
			},
			formOk(){
				this.showForm = false;
				this.getLists();
			},
			formClosed(){
				this.showForm = false;
			},
			editUserAct(res){
				this.detail = res;
				this.showMemberForm = true;
			},
			memberFormOk(){
				this.showMemberForm = false;
				this.getLists();
			},
			memberFormClosed(){
				this.showMemberForm = false;
			},
			delAct(record){
				this.$confirm({
					title:'确认删除这个规则吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/delDiscountRule',{
								rule_id:record.rule_id,
							}).then(res=>{
								this.$message.success('删除成功');
								this.getLists();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			getLists(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/getDiscountRuleList',{
					keyword:this.search.keyword,
					mendian_id:this.search.mendian_id,
					limit:this.pagination.pageSize,
					page:this.pagination.current,
				}).then(res=>{
					this.pagination.total=res.total;
					this.datas=res.list;
					this.maxOpenNum = res.store_num;
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
				})
			},
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current;
				this.getLists();
			},
			searchCancel() {
				this.search = {
					keyword:'',
				};
			},
			searchAct(){
				this.getLists();
			},
			cancelAct(){
				this.searchCancel();
				this.searchAct();
			},
			
			// 下载导入模板
			async importActModel() {
				try {
					// 创建工作簿
					const wb = XLSX.utils.book_new();
					
					// 模板数据
					const templateData = [
						{ mobile: '手机号(11位数字)' },
						{ mobile: '13800138000' },
					];
					
					// 创建工作表
					const ws = XLSX.utils.json_to_sheet(templateData);
					
					// 设置列宽
					const colWidth = [
						{ wch: 25 }  // mobile 列宽
					];
					ws['!cols'] = colWidth;
					
					// 添加工作表到工作簿
					XLSX.utils.book_append_sheet(wb, ws, '用户导入模板');
					
					// 生成文件名
					const fileName = `用户导入模板_${new Date().toLocaleDateString().replace(/\//g, '-')}.xlsx`;
					
					// 导出文件
					XLSX.writeFile(wb, fileName);
					
					this.$message.success('模板下载成功');
				} catch (error) {
					console.error('模板下载失败:', error);
					this.$message.error('模板下载失败');
				}
			},

			// 导入用户弹框
			importUserAct(record) {
				this.importForm.rule_id = record.rule_id;
				this.importVisible = true;
				this.selectedFile = null;
				this.importResult = null;
			},

			// 文件上传前校验
			beforeUpload(file) {
				const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
							file.type === 'application/vnd.ms-excel';
				if (!isExcel) {
					this.$message.error('只能上传 Excel 文件!');
					return false;
				}
				
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('文件大小不能超过 2MB!');
					return false;
				}
				
				this.selectedFile = file;
				return false; // 阻止自动上传
			},

			// 确认导入
			async handleImportOk() {
				if (!this.selectedFile) {
					this.$message.warning('请先选择文件');
					return;
				}
				
				if (!this.importForm.rule_id) {
					this.$message.warning('请选择规则');
					return;
				}

				this.importLoading = true;
				this.importResult = null;

				try {
					// 读取Excel文件
					const data = await this.readExcelFile(this.selectedFile);
					
					// 验证和处理数据
					const processedData = this.processImportData(data);
					console.log('processedData',processedData)
					
					if (processedData.length === 0) {
						this.importResult = {
							type: 'warning',
							message: '导入失败',
							description: '没有有效的数据可导入，请检查文件格式'
						};
						return;
					}

					// 发送到后端
					const response = await this.$http.api('admin/importRuleUsers', {
						rule_id: this.importForm.rule_id,
						users: processedData
					});

					let fail_reasons_str = '';
					if(response.fail_reasons.length > 0){
						fail_reasons_str = response.fail_reasons.join(', ');
					}

					this.importResult = {
						type: 'success',
						message: '导入成功',
						description: `成功导入 ${response.success_count} 条数据，${response.fail_count} 条失败 ${fail_reasons_str}`
					};

					// 6秒后关闭弹框
					setTimeout(() => {
						this.handleImportCancel();
					}, 6000);

				} catch (error) {
					console.error('导入失败:', error);
					this.importResult = {
						type: 'error',
						message: '导入失败',
						description: error.message || '服务器错误，请稍后重试'
					};
				} finally {
					this.importLoading = false;
				}
			},

			// 读取Excel文件
			readExcelFile(file) {
				return new Promise((resolve, reject) => {
					const reader = new FileReader();
					reader.onload = (e) => {
						try {
							const data = new Uint8Array(e.target.result);
							const workbook = XLSX.read(data, { type: 'array' });
							const firstSheetName = workbook.SheetNames[0];
							const worksheet = workbook.Sheets[firstSheetName];
							const jsonData = XLSX.utils.sheet_to_json(worksheet);
							resolve(jsonData);
						} catch (error) {
							reject(error);
						}
					};
					reader.onerror = reject;
					reader.readAsArrayBuffer(file);
				});
			},

			// 处理导入数据
			processImportData(rawData) {
				const validData = [];
				
				rawData.forEach((item, index) => {
					// 跳过表头或空行
					if (index === 0 && item.mobile === '手机号(11位数字)') {
						return;
					}

					// 跳过空行
					if (!item.mobile) {
						return;
					}
					
					// 验证数据
					const mobile = String(item.mobile).trim();
					
					if (!mobile || !/^1[3-9]\d{9}$/.test(mobile)) {
						console.warn(`第${index + 1}行：手机号格式不正确`);
						return;
					}
					
					validData.push({
						mobile: mobile
					});
				});

				console.log('validData',validData)
				
				return validData;
			},

			selectedFileAgain(){
				this.selectedFile = null
				this.importResult = null
			},

			// 取消导入
			handleImportCancel() {
				this.importVisible = false;
				this.selectedFile = null;
				this.importResult = null;
				this.importForm.rule_id = null;
			},

			// 导出用户列表
			async downloadUsers(record) {
				try {
					const response = await this.$http.api('admin/getRuleUsers', {
						rule_id: record.rule_id
					});

					const users = response.users || [];
					
					// 创建工作簿
					const wb = XLSX.utils.book_new();
					const ws = XLSX.utils.json_to_sheet(users);
					
					// 设置列宽
					const colWidth = [
						{ wch: 10 }, // user_id
						{ wch: 15 }, // rule_id  
						{ wch: 20 }, // mobile
						{ wch: 20 }, // create_time
					];
					ws['!cols'] = colWidth;
					
					XLSX.utils.book_append_sheet(wb, ws, '规则用户');
					
					const fileName = `规则_${record.name}_用户列表_${new Date().toLocaleDateString().replace(/\//g, '-')}.xlsx`;
					XLSX.writeFile(wb, fileName);
					
					this.$message.success('用户列表导出成功');
				} catch (error) {
					console.error('导出失败:', error);
					this.$message.error('用户列表导出失败');
				}
			},

			getRuleUserList() {

			}
		}
	}
</script>

<style scoped>
.setting-page {
	min-width: 1080px;
}

.import-container {
	padding: 20px;
}

.file-info {
	padding: 10px;
	background-color: #f5f5f5;
	border-radius: 4px;
	margin-bottom: 15px;
}

.import-result {
	margin-top: 15px;
}

.flex {
	display: flex;
}

.center {
	align-items: center;
	justify-content: center;
}

.more-act {
	padding: 5px 10px;
	cursor: pointer;
}

.menu-act {
	color: rgba(0, 0, 0, 0.65);
}

.menu-act:hover {
	color: #1890ff;
}
</style>